var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { withPathPrefix } from "../../common/helpers";
/** Keeps strings and explicit nulls; anything else (missing, wrong type) becomes undefined. */
function toNullableString(value) {
    return typeof value === "string" || value === null ? value : undefined;
}
function normalizeSuggestionList(raw) {
    if (!Array.isArray(raw))
        return [];
    const out = [];
    for (const x of raw) {
        if (!x || typeof x !== "object")
            continue;
        const o = x;
        if (typeof o.name !== "string" ||
            typeof o.url !== "string" ||
            typeof o.type !== "string") {
            continue;
        }
        out.push({
            type: o.type,
            type_name: typeof o.type_name === "string" ? o.type_name : "",
            name: o.name,
            url: o.url,
            body_types: typeof o.body_types === "string" ? o.body_types : undefined,
            idaggregate: o.idaggregate,
            natcode: toNullableString(o.natcode),
            vin: toNullableString(o.vin),
            img: typeof o.img === "string" && o.img !== "" ? o.img : null,
        });
    }
    return out;
}
/**
 * Supports legacy JSON array of suggestions, or an object:
 * `{ results | items: [...], suggestions?: [...] }` — `suggestions` are shown on empty main results.
 */
function parseSearchPayload(json) {
    if (Array.isArray(json)) {
        return {
            mainItems: normalizeSuggestionList(json),
            noResultSuggestions: [],
        };
    }
    if (json && typeof json === "object") {
        const o = json;
        const mainRaw = o.results !== undefined
            ? o.results
            : o.items !== undefined
                ? o.items
                : Array.isArray(o.data)
                    ? o.data
                    : undefined;
        const suggRaw = o.suggestions !== undefined
            ? o.suggestions
            : o.no_result_suggestions !== undefined
                ? o.no_result_suggestions
                : undefined;
        return {
            mainItems: normalizeSuggestionList(mainRaw),
            noResultSuggestions: normalizeSuggestionList(suggRaw),
        };
    }
    return { mainItems: [], noResultSuggestions: [] };
}
function groupByTypeName(items) {
    const map = new Map();
    for (const item of items) {
        const key = item.type_name || "Suggestions";
        const existing = map.get(key);
        if (existing)
            existing.push(item);
        else
            map.set(key, [item]);
    }
    return Array.from(map.entries()).map(([title, grouped]) => ({
        title,
        items: grouped,
    }));
}
export function createSiteSearchClient() {
    let activeController = null;
    function search(query) {
        return __awaiter(this, void 0, void 0, function* () {
            // Abort any previous request
            if (activeController)
                activeController.abort();
            activeController = new AbortController();
            try {
                const url = withPathPrefix(`/carsell/offers/search?q=${encodeURIComponent(query)}`);
                const res = yield fetch(url, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    },
                    signal: activeController.signal,
                    credentials: "same-origin",
                });
                if (!res.ok) {
                    throw new Error(`Search failed: ${res.status}`);
                }
                const json = (yield res.json());
                const { mainItems, noResultSuggestions } = parseSearchPayload(json);
                return {
                    groups: groupByTypeName(mainItems),
                    noResultSuggestions,
                };
            }
            catch (e) {
                // Return undefined on abort (so the UI doesn't change)
                if (e instanceof DOMException && e.name === "AbortError") {
                    return undefined;
                }
                throw e;
            }
        });
    }
    function abort() {
        if (activeController) {
            activeController.abort();
            activeController = null;
        }
    }
    return { search, abort };
}
